import React from 'react';

const StuClassRouting = () => {
    return (
        <div>
                                   qq  qqqqqqqqqqqqqq Class Routingsdfasd
        </div>
    );
};

export default StuClassRouting;